import { HttpErrorResponse } from '@angular/common/http';

export const FORBIDDEN_INTERNAL_EMPLOYEE_REQUEST_TYPE =
  '/channels/customers/errors/forbidden-internal-employee-request';

export function isForbiddenInternalEmployeeRequest(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) return false;

  const responseType = (error.error as { type?: string } | null)?.type;
  return (
    error.status === 403 &&
    responseType === FORBIDDEN_INTERNAL_EMPLOYEE_REQUEST_TYPE
  );
}